import { getRequest } from "../requests";
import { URL_BASE } from "../constants";

export async function getQuestionsBySubcategory(subcategoryName) {
    const questions = await getRequest(`${URL_BASE}/questions/subcategory?name=${subcategoryName}`);
    return questions.data;
}